import React from "react";
import * as s from "./index.module.scss";
import { PrismicRichText } from "@prismicio/react";

const Richtext = ({ title, description, data }) => {
  return (
    <section
      className={`${s.terms_container} ${data?.rt_grey_bg ? "grey-bg" : ""}`}
    >
      <div className={s.body_container}>
        <div className={s.title_heading}>
          <PrismicRichText field={title || []} />
        </div>
        <div className={`${s.sub_title} secondaryFont`}>
          <PrismicRichText field={description || []} />
        </div>
      </div>
    </section>
  );
};

export default Richtext;
